import { h } from "preact";

import Icon from "./Icon.jsx";

export default function HelpIcon({ children }) {
  return (
    <span class="help-icon">
      <Icon class="help-icon__trigger">help_outline</Icon>
      <div class="help-icon__overlay">{children}</div>
    </span>
  );
}
